const NOTIFICATION_PERIOD_STORAGE_KEY = "mobile_notification_period_hours";

export const NOTIFICATION_PERIOD_OPTIONS = [6, 12, 24];

const DEFAULT_NOTIFICATION_PERIOD_HOURS = 24;

export function getNotificationPeriodHours() {
  try {
    const stored = localStorage.getItem(NOTIFICATION_PERIOD_STORAGE_KEY);
    const parsed = Number(stored);
    if (NOTIFICATION_PERIOD_OPTIONS.includes(parsed)) {
      return parsed;
    }
  } catch {
    // ignore storage errors
  }
  return DEFAULT_NOTIFICATION_PERIOD_HOURS;
}

export function setNotificationPeriodHours(hours) {
  if (!NOTIFICATION_PERIOD_OPTIONS.includes(hours)) {
    return;
  }
  try {
    localStorage.setItem(NOTIFICATION_PERIOD_STORAGE_KEY, String(hours));
  } catch {
    // ignore storage errors
  }
}
